import React, { Component } from 'react';
import { observer } from 'mobx-react';
import UserStore from '../stores/UserStore';
import Navbar from '../components/Navbar';
import Sidebar from '../components/Sidebar';
import Footer from '../components/Footer';
import PageHeader from '../components/PageHeader';


class Base extends Component {

    async getLoginSession() {
        const tokenString = sessionStorage.getItem('loginSession');
        if(tokenString){
            const loginSession = JSON.parse(tokenString);
            //console.log(loginSession)
            UserStore.access_token=loginSession.access_token;
            UserStore.refresh_token=loginSession.refresh_token;
            UserStore.username=loginSession.username;
            UserStore.isLoggedIn=loginSession.isLoggedIn;
            UserStore.roles=loginSession.roles;
            UserStore.loading=loginSession.loading;
            UserStore.picture=loginSession.picture;
            //console.log(UserStore)
        }
    }

    async userContainsRole(role, userRoles) {
       var containsRole = false;
       for (var i = 0; i < userRoles.length; i++) {
           if(userRoles[i]['authority'] === role){
           containsRole = true;
           break;
           }
       }
       return containsRole;
    }

  async componentDidMount(){

      await this.getLoginSession();

      if (UserStore.isLoggedIn){
          //console.log(UserStore.roles)
          UserStore.services = [
          ]
          if(await this.userContainsRole("ROLE_BOSTADSREGISTRET", UserStore.roles)){
              UserStore.services.push({name:'Bostadsregistret', icon:'icon-home2', active:true, url:'/bostadsregistret'});
          }else{
              UserStore.services.push({name:'Bostadsregistret', icon:'icon-home2', active:true, url:'/'});
          }

          if(await this.userContainsRole("ROLE_INDEX_NORMALIZED", UserStore.roles)){
              UserStore.services.push({name:"Index", icon:'icon-graph', active: true, url:'/index'});
          }if(await this.userContainsRole("ROLE_NEWS_ADMIN", UserStore.roles)){
              UserStore.services.push({name:"News admin", icon:'icon-newspaper2', active: true,  pages: [
                    {name:'List news', icon:'newspaper', url:'/news/admin/list'},
                    {name:'Create news', icon:'file-alt', url:'/news/admin/edit'}
                  ]});
         }
          if(await this.userContainsRole("ROLE_AREA_MAP", UserStore.roles)){
              UserStore.services.push({name:'Mapstat', icon:'icon-map', active:true, url:'/mapstat'});
          }
      }else{
          UserStore.loading = false;
          UserStore.isLoggedIn = false;
          UserStore.services = [
              {name:'Bostadsregistret', icon:'icon-home2', active:true, url:'/'}
          ]
      }

  }catch(e){
        UserStore.loading = false;
        UserStore.isLoggedIn = false;
        UserStore.services = [
            {name:'Bostadsregistret', icon:'icon-home2', active:true, url:'/'}
        ]
    }






  render() {
      return (
        <div>

        {/* Main navar */}
        <Navbar></Navbar>
        {/* /Main navbar */}

        	{/* Page content */}
        	<div class="page-content">

        		{/* Main sidebar */}
              <Sidebar></Sidebar>
        		{/* /main sidebar */}

        		{/* Main content */}
        		<div class="content-wrapper">

        			{/* Page header */}
        		  <PageHeader pageTopic={this.props.pageTopic}></PageHeader>
        			{/* /page header */}

        			{/* Content area */}
        			<div class="content pt-0">

              {this.props.mainContent}


        			</div>
        			{/* /content area */}


        			{/* Footer */}
              <Footer></Footer>
        			{/* /footer */}

        		</div>
        		{/* /main content */}

            {/* Right sidebar */}
            {this.props.searchBar}
        		{/* /right sidebar */}


        	</div>
        	{/* /page content */}

        </div>
	     )
  }
}

export default observer(Base);
